module.exports = __webpack_public_path__ + "static/media/tipologia17.7a346d61.png";